export enum CompanyUserActionType {
    Approve = 'approve',
    Reject = 'reject',
    AuthenticationSettings = 'authenticationSettings',
    Copy = 'copy',
    Edit = 'edit',
    ResendEnrollmentLink = 'resendEnrollmentLink',
    SecurityAndPasswordSettings = 'securityAndPasswordSettings',
    Unlock = 'unlock',
    View = 'view',
}

export class UserActionFlags {
    public isUisEnabled = false;

    public canResetUserPassword: boolean = false;
}
